import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LiliAutoComplete, LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import Heading from '../../../../generic-components/Heading';
import { ReactComponent as SuccessIcon } from '../../../../assets/icons/svg/colored-icons/ic-colored-success-new.svg';
import { ReactComponent as CloseIcon } from '../../../../assets/icons/svg/shared/ic-shared-close.svg';
import { trackMixPanel } from '../../../../services/mixpanel.service';
import { countriesList } from '../../consts';

interface IOtherBusinessSelection {
  onClose: () => void;
  supportedCountries: { title: string, value: string }[];
}

export const OtherBusinessSelection = ({ onClose, supportedCountries }: IOtherBusinessSelection) => {
  const [value, setValue] = useState<{title: string, value: string}>({ title: '', value: '' });
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const { t } = useTranslation();
  const [filteredCountries, setFilteredCountries] = useState<{ title: string, value: string }[]>([]);

  const handleSubmit = () => {
    trackMixPanel('Act on Payee Addressbook Screen', { 'Other Country': value.value, Flow: 'International Wire Out' });
    setIsSubmitted(true);
  };

  useEffect(() => {
    const originalList = [...countriesList];
    const valuesToFilter = supportedCountries.map((country) => country.value);
    setFilteredCountries(originalList.filter((country) => !valuesToFilter.includes(country.value)));
  }, [supportedCountries]);

  useEffect(() => {
    const comboboxList: any = document.querySelectorAll('[role="combobox"]');
    // @ts-ignore
    if (comboboxList?.length > 0) {
      comboboxList.forEach((combobox: any) => {
        combobox.addEventListener('focus', (e: any) => {
          // @ts-ignore
          e?.target?.setAttribute('autocomplete', 'new-password');
        });
      });
    }
  }, []);

  useEffect(() => {
    // eslint-disable-next-line no-undef
    const comboboxList: NodeListOf<HTMLElement> = document.querySelectorAll('[role="combobox"]');
    if (comboboxList?.length > 0) {
      comboboxList.forEach((combobox: HTMLElement) => {
        combobox.addEventListener('focus', (e: FocusEvent) => {
          const target = e.target as HTMLElement | null;
          if (target) {
            target.setAttribute('autocomplete', 'new-password');
          }
        });
      });
    }
  }, []);

  return isSubmitted ? (
    <div className='w-[466px] px-[36px] py-[36px] rounded-xl shadow-light bg-bw00 flex flex-col'>
      <div className='fadeIn w-full h-[348px] bg-bw02 rounded-[8px] flex flex-col items-center justify-center mb-[24px]'>
        <SuccessIcon className='w-[60px]' />
        <Heading title={t('MOVE_MONEY.STEPS.VENDOR_MANAGER.OTHER_BUSINESS.SUCCESS_TITLE')} className='font-metricRMedium text-[18px] text-bw08' />
        <Heading title={t('MOVE_MONEY.STEPS.VENDOR_MANAGER.OTHER_BUSINESS.SUCCESS_SUB_TITLE')} className='font-metricRMedium text-[18px] text-bw08' />
      </div>
      <LiliButton onClick={onClose} id='closeSubmitOtherBusiness' type={LiliButtonType.SECONDARY} title={t('MOVE_MONEY.STEPS.VENDOR_MANAGER.OTHER_BUSINESS.SUCCESS_CTA')} />
    </div>
  ) : (
    <div className='fadeIn w-[466px] px-[36px] py-[36px] rounded-xl shadow-light bg-bw00 flex flex-col relative'>
      <Heading title={t('MOVE_MONEY.STEPS.VENDOR_MANAGER.OTHER_BUSINESS.SELECTION_TITLE')} className='font-metricRMedium text-[24px] text-bw08 mb-[6px]' />
      <Heading title={t('MOVE_MONEY.STEPS.VENDOR_MANAGER.OTHER_BUSINESS.SELECTION_SUB_TITLE')} className='font-metricR text-[16px] text-bw07 mb-[30px]' />
      <Heading title={t('MOVE_MONEY.STEPS.VENDOR_MANAGER.OTHER_BUSINESS.SELECTION_HINT_TITLE')} className='font-metricR text-[16px] text-bw07 mb-[30px]' />
      <button className='absolute top-[12px] right-[12px]' type='button' onClick={() => { onClose(); }}>
        <CloseIcon />
      </button>

      <div className='w-full mb-[100px]'>
        <LiliAutoComplete placeholder='Country' onItemSelection={(item) => setValue(item)} selectedItem={value} autoCompleteItems={filteredCountries} />
      </div>

      {value.value && <LiliButton onClick={handleSubmit} id='submitOtherBusiness' type={LiliButtonType.PRIMARY} title={t('MOVE_MONEY.STEPS.VENDOR_MANAGER.OTHER_BUSINESS.MAIN_CTA')} />}
    </div>);
};
